import { EditorLocal } from '../entities/EditorLocal'
import { EditorRemote } from '../entities/EditorRemote'
import { PlayerLocal } from '../entities/PlayerLocal'
import { PlayerRemote } from '../entities/PlayerRemote'

import * as THREE from '../three'

import { System } from './System'

const Entities = {
  player: PlayerLocal,
  playerRemote: PlayerRemote,
  editor: EditorLocal,
  editorRemote: EditorRemote,
}

export class EntitiesSystem extends System {
  constructor(client) {
    super(client)
    this.byId = new Map() // id -> player
    this.entities = new Set()
    this.player = null
  }

  async init() {
    // const player = new PlayerLocal(this.client, {
    //   id: null,
    //   owner: null,
    //   position: [0, 0, 0],
    //   type: 'player',
    //   name: 'Anon',
    // })
    // this.entities.set('$player', player)
    // this.player = player
  }

  setup(datas) {
    // todo: destroy any existing entities (except our player)
    for (const data of datas) {
      this.add(data)
    }
  }

  get(id) {
    return this.byId.get(id)
  }

  add(data, emit) {
    let type = data.type
    if (data.type === 'player' && data.id !== this.client.network.playerId) {
      type = 'playerRemote'
    } else if (data.type === 'editor' && data.id !== this.client.network.playerId) {
      type = 'editorRemote'
    }
    const Entity = Entities[type]
    const entity = new Entity(this.client, data)
    if (type === 'player' || type === 'editor') {
      this.player = entity
    }
    this.byId.set(data.id, entity)
    this.entities.add(entity)
    if (emit) {
      this.client.network.send('entityAdded', data)
    }
  }

  modify(data, emit) {
    const entity = this.byId.get(data.id)
    if (!entity) return
    entity.modify(data)
    if (emit) {
      this.client.network.send('entityModified', data)
    }
  }

  remove(id, emit) {
    const entity = this.byId.get(id)
    if (!entity) return
    this.byId.delete(id)
    this.entities.delete(entity)
    entity.destroy()
    if (emit) {
      this.client.network.send('entityRemoved', id)
    }
  }
}
